'use strict';

/* acceptDraggable allows a function with parameters, which can be called on mouseup.
 * Note that the mouse event is not passed.
 * When nested, the innermost acceptDraggable catches the dragged item.*/

angular.module('posApp').directive('acceptDraggable', (dragItem) => ({
  restrict: 'A',

  link: function ($scope, $element, $attrs) {
    let command = $attrs.acceptDraggable;
    if (command.charAt(command.length - 2) == '(') {
      command = command.replace(')', 'draggedItem)');
    } else {
      command = command.replace(')', ', draggedItem)');
    }
    $element.bind('vmouseup', (event) => {
      if (dragItem.draggedItem) {
        const draggedItem = dragItem.draggedItem;
        //Any parameters given to the command function need to live in the scope(because it's scope.apply), as parameteres passed from the html likely already do.
        $scope.draggedItem = draggedItem;
        $scope.$apply(command);
        dragItem.stop();
      }
    });
  },
}));
